'use strict';

/**
 * library
 */
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);

/**
 * module
 */
import { anchor } from './module/_anchor';
import { disabled } from './module/_disabled';
import { fitimg } from './module/_fitimg';
import { hover } from './module/_hover';
import { inview } from './module/_inview';
import { scroll } from './module/_scroll';
import { carousel } from './module/_carousel';

/**
 * main
 */
const main = (() => {
    /**
     * loaded
     */
    const loaded = () => {
        inview.init();
        scroll.init();

        $('body').addClass('is-loaded');
    };

    /**
     * init
     */
    const init = () => {
        anchor.init();
        disabled.init();
        fitimg.init();
        hover.init();
        carousel.init();

        justHeight();
        $(window).on('resize', function () {
            justHeight();
        });
    };

    const justHeight = () => {
        let winH = $(window).height();
        $('.js-hero').outerHeight(winH);
    }

    // public
    return {
        init: init,
        loaded: loaded
    };
})();

$(() => {
    main.init();

    $('body')
        .imagesLoaded()
        .done(instance => {
            main.loaded();
        })
        .fail(() => {
            main.loaded();
        });
});
